import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import posthog from 'posthog-js';

posthog.init('phc_t79Jhgzcw3SEsSVX95BJe1N8NJUlCE7YUTYuUSaVqi7', {
  api_host: 'https://eu.i.posthog.com',
  person_profiles: 'identified_only',
  capture_pageview: true,
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);
